enum AddressFunction {
  HQ = 'HQ',
  Office = 'Office',
  Worksite = 'Worksite',
  Shop = 'Shop',
  Mailbox = 'Mailbox',
}

export default AddressFunction;
